<div class="number-selector-container">
	<div class="number-selector">
		<ion-icon
			class="single-stepper"
			name="remove-outline"
			[color]="selectedValue === 0 ? 'light' : 'primary'"
			(click)="subtract(1)"
		></ion-icon>

		<div class="digit-container" *ngFor="let place of visiblePlaces; last as isLast">
			<ion-icon name="chevron-up-outline" color="primary" (click)="addType(place)"></ion-icon>
			<div class="digit-value" [class.last-digit]="isLast">
				{{ model[place] }}
			</div>
			<ion-icon name="chevron-down-outline" color="primary" (click)="subtractType(place)"></ion-icon>
		</div>

		<ion-icon
			class="single-stepper"
			name="add-outline"
			[color]="maxValue === selectedValue ? 'light' : 'primary'"
			(click)="add(1)"
		></ion-icon>
	</div>
</div>
